export const STAGE_TITLE = 0;
export const STAGE_DETAIL = 1;
export const STAGE_APPOINTMENT = 2;
export const STAGE_POSTED = 3;



// WEBPACK FOOTER //
// ./src/components/support/stages.js